<template>
    <nav class="breadcrumb">
        <template v-if="getBreadcrumbLayers.length">
            <template v-for="(layer, index) in getBreadcrumbLayers">
                <a class="breadcrumb__link" @click.prevent="navigateTo(layer.route)">
                {{ layer.label }}
                </a>
                <span
                    v-if="index < getBreadcrumbLayers.length - 1 || (theme === 'microlearning')"
                    class="breadcrumb__separator"
                >
                •
                </span>
            </template>
        </template>
    </nav>
</template>
  
<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'breadcrumb',
        props: {
            theme: {
                type: String,
                validator: (prop) => [ 'course', 'microlearning' ].includes(prop),
                default: 'course'
            }
        },
        data () {
            return {
                urlRoute: null
            }
        },
        computed: {
            ...mapGetters({
                lastRoute: 'Breadcrumb/getLastRoute',
                categories: 'Menu/getCategories',
                userMenu: 'Menu/getUserMenu',
                learningPath: 'LearningPaths/getSingleLearningPath',
                collection: 'CoursesCollections/getSingleCollection'
            }),
            subjectAreas () {
                return this.categories.map(el => ({
                    label: el.translatedName,
                    code: el.slug,
                    customerSpecific: el.customerSpecific
                }))
            },
            getBreadcrumbLayers() {
                const layers = []
                const routeParams = this.lastRoute?.params || this.$route.params || {}
                const routeQuery = this.lastRoute?.query || this.$route.query || {}
                const packageSlug = routeParams.packageSlug
                const learningPathSlug = routeParams.learningPathSlug
                const collectionSlug = routeParams.collectionSlug
                const currentRouteName = this.$route.name

                // Handle first breadcrumb layer
                if (packageSlug) {
                    const subjectArea = this.subjectAreas.find(el => el.code === packageSlug)
                    layers.push({
                        label: subjectArea?.label || this.$t('StoreMenu.all_subject_areas'),
                        route: {
                            name: 'all-content',
                            params: { packageSlug },
                            query: routeQuery
                        }
                    })
                } else {
                    // Handle cases with no packageSlug: fallback to lastRoute or general
                    if (!this.lastRoute) {
                    layers.push({
                        label: this.$t('StoreMenu.all_subject_areas'),
                        route: { name: 'all-content', params: {}, query: {} }
                    })
                    } else {
                        switch (this.lastRoute.name) {
                            case 'all-packages-course-list':
                            case 'all-packages-all-content':
                            case 'all-packages-collection-list':
                            case 'all-packages-learning-paths':
                            case 'all-packages-virtual-classrooms':
                            case 'all-packages-live-events':
                            layers.push({
                                label: this.$t('StoreMenu.all_subject_areas'),
                                route: {
                                name: this.lastRoute.name,
                                params: this.lastRoute.params,
                                query: routeQuery
                                }
                            })
                            break
                            default:
                            layers.push({
                                label: this.$t('StoreMenu.all_subject_areas'),
                                route: {
                                    name: 'all-packages-all-content',
                                    params: {},
                                    query: routeQuery
                                }
                            })
                            break
                        }
                    }
                }
                if (learningPathSlug && currentRouteName !== 'learning-path-page' && currentRouteName !== 'learning-path-without-package') {
                    layers.push({
                    label: this.learningPath?.title || this.formatSlugLabel(learningPathSlug),
                    route: {
                        name: 'learning-path-page',
                        params: { ...(packageSlug ? { packageSlug } : {}), learningPathSlug },
                        query: routeQuery
                    }
                    })
                }
                else if (collectionSlug && currentRouteName !== 'collection-page' && currentRouteName !== 'collection-without-package') {
                    layers.push({
                    label: this.collection?.title || this.formatSlugLabel(collectionSlug),
                    route: {
                        name: 'collection-page',
                        params: { ...(packageSlug ? { packageSlug } : {}), collectionSlug },
                        query: routeQuery
                    }
                    })
                }
                return layers
            }
        },
        methods: {
            navigateTo (route) {
                if (route && route.name) {
                    this.$router.push({
                        name: route.name,
                        params: route.params,
                        query: route.query
                    })
                }
            },
            formatSlugLabel (slug) {
                const parts = slug.split('-').slice(1)
                return parts.join(' ').replace(/\b\w/g, l => l.toUpperCase())
            }
        }
    }
</script>

<style lang="scss" scoped>
    .breadcrumb {
        display: flex;
        align-items: center;
        font-size: 1.4rem;
        color: $carbon;

        &__link { 
            text-decoration: underline;
            color: $lavender;
            cursor: pointer;
            font-size: 1.6rem;
        }

        &__separator {
            margin: 0 5px;
            font-size: 1.6rem;
            color: $lavender;

            [class*="mobile"] & {
                margin: 0px 10px 0px 10px;
            }
        }
    }

</style>
  